import type { SearchableSelectOption } from '@/components/ui/SearchableSelect'
import type {
  PropertyStaffRow,
  TransferEmployeeSubTab,
  TransferProgressJson,
  TransferTabId,
  TransferWizardFormValues,
} from '../types'
import { defaultTransferFormValues } from './transferFormUtils'

export type TransferParseProgressHandlers = {
  setPropertyList: (v: SearchableSelectOption[]) => void
  setCompanyList: (v: SearchableSelectOption[]) => void
  setLoadNewCompany: (v: { company_name: string }) => void
  setCompanyListOld: (v: SearchableSelectOption[]) => void
  setInfoDone: (v: boolean) => void
  setNewPropertySave: (v: string) => void
  setDomains: (v: string) => void
  setNewdomains: (v: string) => void
  resetForm: (values: TransferWizardFormValues) => void
  onFirstFormReset: () => void
  setRemovestaffList: (v: PropertyStaffRow[]) => void
  setTransferstaffList: (v: PropertyStaffRow[]) => void
  setAddedstaffList: (v: PropertyStaffRow[]) => void
  setCommitstaffList: (v: PropertyStaffRow[]) => void
  setCommitDone: (v: boolean) => void
  setVerifyDone: (v: boolean) => void
  setEmpDone: (v: boolean) => void
  setPrimaryContactSet: (v: boolean) => void
  setSelectedTab: (v: TransferTabId) => void
  setSelectedSubTab: (v: TransferEmployeeSubTab) => void
  setResidentDone: (v: boolean) => void
  setResidentcount: (v: number) => void
  setApplicantcount: (v: number) => void
}

export function parseTransferProgressData(
  pd: TransferProgressJson,
  handlers: TransferParseProgressHandlers,
) {
  if (pd.propertyinfo?.info) {
    if (pd.propertyinfo.propertylist) {
      handlers.setPropertyList(pd.propertyinfo.propertylist as SearchableSelectOption[])
    }
    if (pd.propertyinfo.companylist) {
      handlers.setCompanyList(pd.propertyinfo.companylist as SearchableSelectOption[])
      const fkId = String((pd.propertyinfo.info as { fk_company_id?: unknown })?.fk_company_id ?? '')
      const matched = (pd.propertyinfo.companylist as SearchableSelectOption[]).find(
        (c) => String(c.value) === fkId,
      )
      if (matched) handlers.setLoadNewCompany({ company_name: matched.label })
    }
    if (pd.propertyinfo.companylistOld) {
      handlers.setCompanyListOld(pd.propertyinfo.companylistOld as SearchableSelectOption[])
    }
    handlers.setInfoDone(!!pd.propertyinfo.infodone)
    if (pd.propertyinfo.newPropertySave) {
      handlers.setNewPropertySave(String(pd.propertyinfo.newPropertySave))
    }
    if (pd.propertyinfo.infodone && pd.propertyinfo.newPropertySave && !pd.contactsinfo?.commitdone) {
      handlers.setSelectedTab('contactsinfo')
    }
    handlers.setDomains(String(pd.propertyinfo.domains || ''))
    handlers.setNewdomains(String(pd.propertyinfo.newdomains || ''))
    setTimeout(() => {
      handlers.resetForm({
        ...defaultTransferFormValues(),
        ...(pd.propertyinfo!.info as unknown as TransferWizardFormValues),
      })
      handlers.onFirstFormReset()
    }, 100)
  }
  if (pd.contactsinfo) {
    if (pd.contactsinfo.removelist) handlers.setRemovestaffList(pd.contactsinfo.removelist)
    if (pd.contactsinfo.transferlist) handlers.setTransferstaffList(pd.contactsinfo.transferlist)
    if (pd.contactsinfo.addlist) handlers.setAddedstaffList(pd.contactsinfo.addlist)
    if (pd.contactsinfo.commitstaffList) handlers.setCommitstaffList(pd.contactsinfo.commitstaffList)
    handlers.setCommitDone(!!pd.contactsinfo.commitdone)
    handlers.setVerifyDone(!!pd.contactsinfo.verifydone)
    handlers.setEmpDone(!!pd.contactsinfo.empdone)
    handlers.setPrimaryContactSet(!!pd.contactsinfo.primarycontactset)
    if (pd.contactsinfo.empdone) {
      handlers.setSelectedTab('residentinfo')
    } else if (pd.contactsinfo.commitdone) {
      handlers.setSelectedTab('contactsinfo')
      if (!pd.contactsinfo.verifydone) handlers.setSelectedSubTab('addstaff')
    }
  }
  if (pd.residentinfo) {
    handlers.setResidentDone(!!pd.residentinfo.residentdone)
    handlers.setResidentcount(Number(pd.residentinfo.residentcount || 0))
    handlers.setApplicantcount(Number(pd.residentinfo.applicantcount || 0))
    if (pd.residentinfo.residentdone) handlers.setSelectedTab('summaryinfo')
  }
}
